import APIClient from "../client";

const vehiclesAPI = {
  get: () => {
    return APIClient.get("/vehicle");
  },
  create: (payload) => {
    return APIClient.post("/vehicle", payload);
  },
  delete: (id) => {
    return APIClient.delete(`/vehicle/${id}`);
  },
  activate: (id) => {
    return APIClient.patch(`/vehicle/${id}/activate`);
  },
  deactivate: (id) => {
    return APIClient.patch(`/vehicle/${id}/deactivate`);
  },
};

export default vehiclesAPI;
